import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../../environments/environment';
import { AnalyticsConstants } from '../../../../shared/constants/Analytics';
import { ErrorFormatter } from '../../../../shared/formatter/error.formatter';
import { SendWhatsAppContactInput } from '../../../../shared/models/lead/sendWhatsapp.input';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { TrackAnalyticsService } from '../../../../shared/services/track-analytics/track-analytics.service';
import { PhoneService } from '../../../../shared/services/utils/phone.service';
import { ToastService } from '../../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';

export abstract class WhatsappSenderComponent implements OnInit {
    whatsappContactInput: SendWhatsAppContactInput;

    get f(): any {
        return this.whatsAppForm.controls;
    }
    whatsappMessage: string;
    leadId: string;
    contactPhone: string;

    whatsAppForm: FormGroup;
    sending = false;
    constructor(
        protected readonly formBuilder: FormBuilder,
        protected readonly spinner: NgxSpinnerService,
        protected readonly leadService: LeadService,
        protected readonly toasterService: ToastService,
        protected readonly leadComuService: LeadsComunicationService,
        protected readonly translator: TranslatorService,
        protected readonly errorFormatter: ErrorFormatter,
        protected readonly trackAnalytics: TrackAnalyticsService,
        protected readonly phoneService: PhoneService,
    ) {

    }

    ngOnInit(): void {
        this.whatsAppForm = this.formBuilder.group({
            comments: ['', Validators.required]
        });
    }

    sendWhatsapp(): void {

        this.spinner.show();
        if (this.whatsAppForm.invalid) {
            this.spinner.hide();

            return;
        }

        this.whatsappContactInput = new SendWhatsAppContactInput();
        this.whatsappContactInput.whatsAppContact = {
            body: this.f.comments.value,
            leadId: this.leadId
        };

        this.send();

    }

    openWhatsapp(phone: string): Window {
        this.trackAnalytics.sendEvent(AnalyticsConstants.CATEGORY_CONTACT, AnalyticsConstants.EVENT_WHATSAPP);

        if (this.f.comments.value.indexOf('/#/') !== -1) {
            return window.open(`${environment.whatsappApi}?phone=${phone}&text=${this.f.comments.value.replace('#', '%23')}`);
        }
        return window.open(`${environment.whatsappApi}?phone=${phone}&text=${encodeURI(this.f.comments.value)}`);
    }

    abstract handlerWhatsappSended();

    abstract send();

    private openWindowWhatsapp(): void {
        this.openWhatsapp(this.phoneService.generateNumberForWhatsapp(this.contactPhone));
    }

    protected whatsappSendedHandler = () => {
        this.sending = true;
        this.handlerWhatsappSended();
        // this.modalService.dismissAll();
        this.whatsappMessage = null;
        this.leadComuService.launchReloadMyLead(this.whatsappContactInput.whatsAppContact.leadId);
        this.openWindowWhatsapp();
        this.whatsAppForm.reset();
        this.toasterService
            .showToast(
                'success',
                'toaster.whatsapp.succes.title',
                'toaster.whatsapp.success_body'
            );
        this.spinner.hide();
        this.sending = false;

    }

    protected whatsappSendedError = (error) => {
        this.toasterService
            .showToast(
                'error',
                this.translator.trans('toaster.whatsapp.error'),
                this.errorFormatter.formatErrors(error.graphQLErrors)
            );
        this.sending = false;
        this.spinner.hide();
    }

}
